import { all, call, put, select } from 'redux-saga/effects';

import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/invoice.api';
import { invoiceSelectors } from './invoice.selectors';

import * as actions from './invoice.actions';
import * as types from './invoice.types';

const normalizeInvoice = (invoice: types.IInvoice): types.IInvoice => ({
  ...invoice,
  id: String(invoice.id),
});

export function* storeInvoice(invoice: types.IInvoice) {
  yield put(actions.storeInvoice(invoice));
  return invoice;
}

export function* clearInvoice(invoiceId: types.IInvoice['id']) {
  yield put(actions.clearInvoice(invoiceId));
}

export function* clearAllInvoices() {
  const invoiceIds: types.IInvoice['id'][] = yield select(invoiceSelectors.selectResourceIds);
  yield put(actions.clearInvoice(invoiceIds));
}

function* storeListedInvoice(item: types.IInvoiceListItem) {
  const normalized = { ...item, id: String(item.id) };
  const existing = (yield select(invoiceSelectors.selectResourceById, normalized.id)) as types.IInvoice | undefined;
  if (existing) {
    yield call(storeInvoice, { ...existing, ...normalized });
    return;
  }

  yield call(storeInvoice, normalized as types.IInvoice);
}

export function* getInvoices(page = 1, limit = 10) {
  const response = (yield call(apiRequest, api.getInvoicesApi({ page, limit }))) as types.IInvoiceListResult | null;
  if (!response) {
    return null;
  }

  const items = response.items.map((item) => ({
    ...item,
    id: String(item.id),
  }));
  yield all(items.map((item) => call(storeListedInvoice, item)));

  return {
    ...response,
    items,
  };
}

export function* getInvoiceById(invoiceId: types.IInvoice['id']) {
  const invoice = (yield call(apiRequest, api.getInvoiceApi(invoiceId))) as types.IInvoice | null;
  if (!invoice) {
    return null;
  }

  const normalized = normalizeInvoice(invoice);
  yield call(storeInvoice, normalized);
  return normalized;
}
